// extracted by mini-css-extract-plugin
export default {"checkmark":"u0Nr5___Checkmark-module__checkmark","show":"J7lGS___Checkmark-module__show"};